import { GameData } from './Games.types';
import { SectionNavBarButtonOptions } from '../atoms/SectionNavButton.types';
import IndexCardsGame from './IndexCards/IndexCardsGame';
import GapText from './GapText/GapText';
import HighlightTerms from './HighlightTerms/HighlightTermsGame';
import SelectItems from './SelectItems/SelectItems';
import CategoryDrop from './CategoryDrop/CategoryDrop';
import GoNogo from './GoNogo/Gonogo';
import ApproachAvoidRouter from './ApproachAvoid/ApproachAvoidRouter';
import CheckFeedback from './CheckFeedback/CheckFeedback';

type Properties = {
    item: GameData
    setNextButtonLabel: (label: string | undefined) => void;
    setNextButtonDisabled: (disabled: boolean) => void;
    setNavBarLeftButton: (options: SectionNavBarButtonOptions | undefined) => void;
    setNavBarRightButton: (options: SectionNavBarButtonOptions | undefined) => void;
};

const Game = (props: Properties) => {
    const { item, setNextButtonDisabled, setNextButtonLabel, setNavBarLeftButton, setNavBarRightButton } = props;

    // Game Components manage db communication themselves
    const getGame = (): JSX.Element => {
        switch (item.gametype) {
            case 'index_cards':
                return <IndexCardsGame
                    data={item}
                    setNextButtonDisabled={setNextButtonDisabled}
                />;
            case 'gap_text':
                return <GapText
                    data={item}
                />;
            case 'highlight_terms':
                return <HighlightTerms
                    data={item}
                    setNextButtonLabel={setNextButtonLabel}
                />;
            case 'select_items':
                return <SelectItems
                    data={item}
                    setNextButtonLabel={setNextButtonLabel}
                />;
            case 'category_drop':
                return <CategoryDrop
                    data={item}
                    setNextButtonLabel={setNextButtonLabel}
                />;
            case 'gonogo':
                return <GoNogo
                    data={item}
                    setNextButtonLabel={setNextButtonLabel}
                />;
            case 'approach_avoid':
                return <ApproachAvoidRouter
                    data={item} 
                    setNavBarLeftButton={setNavBarLeftButton}
                    setNavBarRightButton={setNavBarRightButton}
                />;
            case 'check_feedback':
                return <CheckFeedback
                    data={item}
                    setNextButtonLabel={setNextButtonLabel}
                />;
            default:
                return <div>Game ist nicht unterstützt.</div>;
        }
    };

    return getGame();
};
export default Game;
